import { NgModule } from '@angular/core';
import { CommonModule as  CommonModule } from '@angular/common';
import { NoveltyUserComponent } from './components/novelty-user/novelty-user.component';
import { DialogModule } from '../common/dialog.module';
import { LoadingOverlayModule } from '../common/loading-overlay.module';
import { ErrorDialogComponent } from '../common/errorHandling/errorDialog.component';

@NgModule({
  imports: [
    CommonModule,
    DialogModule,
    LoadingOverlayModule
  ],
  declarations: [NoveltyUserComponent, ErrorDialogComponent],
  exports: [
    NoveltyUserComponent,
    ErrorDialogComponent
  ]
})
export class NoveltyUserModule { }
